import React, { useContext, useEffect } from "react";
import { Data } from "../App";
import { Helmet } from "react-helmet";
import FormSteps from "./FormSteps";
import "./form.scss";

export default function Thanks() {
  const { setSelectedList, formData, setFormData, errors, setErrors } =
    useContext(Data);

  // フォームデータをリセット
  useEffect(() => {
    window.scrollTo(0, 0);
    setSelectedList([]);
    setFormData({
      ...formData,
      name: "",
      lastname: "",
      furigana1: "",
      furigana2: "",
      post: "",
      pref: "",
      address1: "",
      address2: "",
      streetno1: "",
      streetno2: "",
      streetno3: "",
      building: "",
      email: "",
      emailcheck: "",
      enquate1: "",
      enquate2: "",
      enquate3: "",
      enquate4: "",
      enquate5: "",
      message: "",
      mm: "希望する",
      kijiname: [],
    });
    setErrors({
      ...errors,
      name: "",
      lastname: "",
      furigana1: "",
      furigana2: "",
      post: "",
      pref: "",
      address1: "",
      address2: "",
      streetno1: "",
      streetno2: null,
      streetno3: null,
      building: null,
      email: "",
      emailcheck: "",
      message: null,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet>
        <title>請求完了 | 生地サンプル請求 | 国産ソファブランド NOYES</title>
      </Helmet>

      <div className="thanks_wrapper">
        <h1>生地サンプル請求</h1>
        <FormSteps />
        <p>
          ご到着まで今しばらくお時間がございますが、どうぞ楽しみにお待ちいただけましたら幸いでございます。
        </p>
        <div className="thanks_info">
          <div>
            <h2>
              <b>生地サンプルがお手元に届くまで</b>
            </h2>
            <h4>大切なお客様へ</h4>
            <p>
              この度は生地サンプルをご請求いただきまして誠にありがとうございます。お申し込みから4日営業日以内にご発送いたします。発送準備が整いましたら、お知らせのメールをお送りいたしますので、もう暫くお待ちくださいませ。
              <br />
              尚、ご請求が集中した場合、発送までにお時間がかかる場合がございます。その際は何卒ご了承くださいますようお願い申し上げます。
              <br />
              【年末年始休業のご案内】 <br />
              誠に勝手ではございますが、12月29日(火)〜1月5日(火)の期間を休業とさせていただきます。 <br />
              この期間のお申し込み分につきましては翌営業日の「1月6日(水)」より順次発送させていただきます。
            </p>
            <h4>請求内容のご変更など</h4>
            <p>
              ご請求確認メールが届かなかった場合は、メールアドレスの入力ミスなどの可能性がありますので、
              <b>info@ny-k.co.jp</b>まで至急ご連絡ください。
              <br />
              <br />
              また、生地やカラーのお間違いや、ご住所の入力ミス、その他お間違いがありましたら、いつでもお気軽に
              <b>info@ny-k.co.jp</b>までご連絡ください。
            </p>
          </div>
        </div>
        {/* <div class="line">
          <img src="/material/images/line_coordinate.jpg" alt="line" />
          <h2>LINEでコーディネート</h2>
          <p>お客様のご検討ソファにピッタリな生地を一緒にお探しします。</p>
          <a class="base_link" href="/line_coordinate/">
            more
          </a>
        </div> */}
      </div>
    </>
  );
}
